import React from 'react';

export const useTriggerMailService = () => {
  const triggerMailService = async () => {
    const url = process.env.REACT_APP_WEBAPI.replace('graphql', 'triggermailservice');
    fetch(url);
  };

  return { triggerMailService };
};
